const info = {
  ZH: { //中文翻译
    contactUs:"联系我们",
    CustomerSCI: '客服联系方式',
    HSPhone:"联系电话(微信同号)：",
    ServiceEmail:"服务邮箱：:",
    Customerservicetime:"工作时间：",
    mToF:"周一到周五",
    esh:"法定节假日除外",
    QA:"常见问题",
    FAS:"反馈建议",
    searchKey:"关键词搜索",
    problemclassification:"问题分类",
    Whetherortop:"是否置顶",
    classificationSearch:"分类搜索",
    allowPublicDisclosure:"允许公开",
    timeline:"时间线",
    processingPlan:"处理方案",
    操作人:"操作人",
  },
  EN: { //英文翻译
    contactUs: 'Contact us',
    CustomerSCI: 'Customer service contact information',
    CHSPhone:"CAMDS human service Phone (WeChat same number):",
    ServiceEmail:"Service Email:",
    Customerservicetime:"Customerservicetime:",
    mToF:"Monday to Frida",
    esh:"Excluding statutory holidays",
    QA:"FAQ",
    FAS:"Feedback and suggestions",
    searchKey:"Search by keyword",
    problemclassification:"Problem classification",
    Whetherortop:"Whether to top",
    classificationSearch:"Classification search",
    allowPublicDisclosure:"Allow public disclosure",
    timeline:"Timeline",
    processingPlan:"Processing plan",
    操作人:"Operator"
  }
}
export default info //需要暴露出去